/**
 * Checks if the application is running in local development environment.
 * Returns true if NODE_ENV is not 'production' or if VUE_APP_IS_LOCAL is set to 'true'.
 */
export const isLocal = (): boolean => {
  return (
    process.env.NODE_ENV !== "production" ||
    process.env.VUE_APP_IS_LOCAL === "true"
  );
};
